import React from 'react';
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="bg-[var(--dark)] px-5 py-10 pb-20 text-center border-t border-[var(--border)]" data-id="element-53">
      <div className="text-[22px] font-black mb-4" data-id="element-54">
        CÓDIGO<span className="text-[var(--red2)]" data-id="element-55">ROJO</span>
      </div>

      <div className="flex justify-center gap-5 mb-4 flex-wrap" data-id="element-56">
        <button onClick={onOpenPrivacy} className="text-[var(--muted)] text-[13px] cursor-pointer hover:text-white transition-colors bg-transparent border-none" data-id="element-57">
          Política de Privacidad
        </button>
        <button onClick={onOpenTerms} className="text-[var(--muted)] text-[13px] cursor-pointer hover:text-white transition-colors bg-transparent border-none" data-id="element-58">
          Términos y Condiciones
        </button>
      </div>

      <p className="text-[var(--muted)] text-[13px] mb-4 leading-relaxed" data-id="element-59">
        ¿Tienes alguna pregunta o duda?
        <br data-id="element-60" />
        <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--accent)] font-semibold hover:text-white transition-colors" data-id="element-61">
          Contáctanos aquí →
        </a>
      </p>

      <p className="text-[var(--muted)] text-xs" data-id="element-62">
        © 2026 · Todos los derechos reservados · Producto digital
        <br data-id="element-63" />
        Este producto es solo para fines educativos e informativos.
      </p>
    </footer>;
}